import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import configureStore from './store';
import initialState from './store/initialState';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'katex/dist/katex.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './index.css';

const store = configureStore(initialState);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);
